"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var hydrationHelpers_1 = require("../hydrationHelpers");
var c = (0, BemBuilder_1.default)("section");
var Description = function (_a) {
    var content = _a.content, dataQwilrComponent = _a["data-qwilr-component"];
    return (react_1.default.createElement(hydrationHelpers_1.ContentArea, { "data-qwilr-component": dataQwilrComponent || undefined, className: c("description-text") }, content.content));
};
exports.default = Description;
